import React, { useCallback, useState } from 'react'
import update from 'immutability-helper'
import { useDrop } from 'react-dnd'
import DraggableBox from './DraggableBox'
import { ItemTypes } from './utils/ItemTypes'
import { snapToGrid as doSnapToGrid } from './utils/snapToGrid'
import styles from './DragAndDrop.module.scss'

export default function Container({ snapToGrid, fields, setFields, imageUrl, template, hideBoundingBoxes }) {
  const [additionalStyles, setAdditionalStyles] = useState({})

  // update x and y position of fields
  const moveBox = useCallback(
    (item, left, top) => {
      item.object.x = left
      item.object.y = top
      setFields(
        update(fields, {
          [item.id]: {
            $merge: { left, top },
          },
        }),
      )

      item.object.save()
    },
    [fields],
  )

  // update width and height of fields after resize
  const resizeBox = useCallback(
    (id, width, height) => {
      setFields(
        update(fields, {
          [id]: {
            $merge: { width, height },
          },
        }),
      )
    },
    [fields],
  )

  const [, drop] = useDrop(
    () => ({
      accept: ItemTypes.BOX,
      drop(item, monitor) {
        const delta = monitor.getDifferenceFromInitialOffset()
        let left = Math.round(item.left + delta.x)
        let top = Math.round(item.top + delta.y)
        if (snapToGrid) {
          [left, top] = doSnapToGrid(left, top)
        }

        moveBox(item, left, top)
        return undefined
      },
    }),
    [moveBox],
  )

  return (
    <div ref={drop} className={styles.container} style={additionalStyles}>
      <img
        onLoad={({ target: img }) => {
          const { offsetHeight, offsetWidth } = img

          const height = template.scaling_factor && offsetHeight ? (offsetHeight / template.scaling_factor) : offsetHeight;
          const width = template.scaling_factor && offsetWidth ? (offsetWidth / template.scaling_factor) : offsetWidth;

          setAdditionalStyles({ height: height, width: width })
        }}
        className={`${styles.templateImg} ${!template.use_new_scaling && styles.restrictDimensions}`}
        style={{
          maxHeight: template.scaling_factor && additionalStyles.height,
          maxWidth: template.scaling_factor && additionalStyles.width,
        }}
        src={imageUrl}
      />
      {Object.keys(fields).map((key) => (
        <DraggableBox key={key} id={key} {...fields[key]} onResize={resizeBox} hideBoundingBoxes={hideBoundingBoxes} />
      ))}
    </div>
  )
}
